import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {Subject} from "rxjs";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslocoPipe} from "@ngneat/transloco";
import {RouterLink} from "@angular/router";
import {NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet} from "@angular/common";


@Component({
    selector: 'terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        MatButton,
        MatIcon,
        MatTooltip,
        TranslocoPipe,
        RouterLink,
        NgIf,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        NgTemplateOutlet

    ]
})
export class AgreementsDocs implements OnInit, OnDestroy {
    agreementType:string = "terms-and-conditions"
    componentDestroyed$: Subject<boolean> = new Subject();
    @Input()
    set type(type: string) {
        this.agreementType = type;
    }

    /**
     * Constructor
     */
    constructor(

    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    ngOnDestroy() {
        this.componentDestroyed$.next(true)
        this.componentDestroyed$.complete()
    }

}
